import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const NextShippingCaption = styled.span`
  text-align: left;
  font: normal normal 300 12px/15px Lato;
  letter-spacing: 0.24px;
  color: #d14a16;
  display: block;
  text-transform: none;
`;

const NextShippingTimer = styled.span`
  font: normal normal bold 12px/20px Lato;
  padding: 0 3px;
  text-transform: none;
`;

const calculateTimeLeft = function () {
  var dayOfWeek = 1;
  var cDate = new Date();
  var nextMonday = new Date();
  nextMonday.setDate(cDate.getDate() + (7 + dayOfWeek - cDate.getDay()));
  nextMonday.setHours(0);
  nextMonday.setMinutes(0);

  const total = nextMonday.getTime() - cDate.getTime();
  return {
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / 1000 / 60) % 60),
  };
};

export const Timer = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 5000);
  });

  return (
    <NextShippingCaption>
      Order within
      <NextShippingTimer>
        {timeLeft.days} day(s) {timeLeft.hours} hr {timeLeft.minutes} mins
      </NextShippingTimer>
      to get on the next shipment
    </NextShippingCaption>
  );
};
